import { render, staticRenderFns } from "./texture.vue?vue&type=template&id=256d4e89&scoped=true"
import script from "./texture.vue?vue&type=script&lang=js"
export * from "./texture.vue?vue&type=script&lang=js"
import style0 from "./texture.vue?vue&type=style&index=0&id=256d4e89&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "256d4e89",
  null
  
)

export default component.exports